import { Egenskapstype, EgenskapTillattVerdi } from '@/domain/vegobjekter/Egenskapstype';
import { Operator, OperatorE } from './Operator';

export type EgenskapsfilterVerdi = EgenskapTillattVerdi | number | string | null;
export type ValidEgenskapsfilter = Egenskapsfilter & { operator: OperatorE };

export class Egenskapsfilter {
    constructor(
        readonly egenskapstype: Egenskapstype,
        readonly operator: OperatorE | null,
        readonly verdi: EgenskapsfilterVerdi = 'Har ikke verdi'
    ) {}

    toString(): string {
        if (!this.egenskapstype || this.operator === null) return '';
        return (
            this.egenskapstype.id + Operator.asString(this.operator) + this.verdiToQuery()
        );
    }

    // Quote strings using single quotes, every other egenskapstype is left untouched
    verdiToQuery(): string {
        if (
            this.operator === OperatorE.HAS_VALUE ||
            this.operator === OperatorE.NO_VALUE
        ) {
            return 'null';
        } else if (this.egenskapstype.maaQuotes()) {
            return "'" + this.verdiToString() + "'";
        } else {
            return this.verdiToString();
        }
    }
    verdiToString(): string {
        if (
            this.operator === OperatorE.HAS_VALUE ||
            this.operator === OperatorE.NO_VALUE
        ) {
            return 'null';
        } else if (this.verdi !== 0 && !this.verdi) {
            return '';
        } else if (this.verdi instanceof EgenskapTillattVerdi) {
            return this.verdi.id.toString();
        } else {
            return this.verdi.toString();
        }
    }

    verdiValue(): string | number | null {
        if (
            this.operator === OperatorE.HAS_VALUE ||
            this.operator === OperatorE.NO_VALUE
        ) {
            return null;
        } else if (this.verdi !== 0 && !this.verdi) {
            return '';
        } else if (this.verdi instanceof EgenskapTillattVerdi) {
            return this.verdi.id;
        } else {
            return this.verdi;
        }
    }

    verdiTypeToString() {
        if (this.verdi instanceof EgenskapTillattVerdi) {
            return this.verdi.verdi;
        } else if (typeof this.verdi === 'number') {
            return this.verdi.toString();
        } else {
            return this.verdi;
        }
    }

    isValid(): this is ValidEgenskapsfilter {
        return (
            this.egenskapstype !== null &&
            this.operator !== null &&
            (this.verdi !== null ||
                this.operator === OperatorE.NO_VALUE ||
                this.operator === OperatorE.HAS_VALUE)
        );
    }
}
